import React from 'react';
import bgImg from '../../assets/img/skill_bg.jpg';
import leftImg from '../../assets/img/skill_img.jpg';
import SkillBar from './SkillBar';

function SkillSet() {
    return (
        <section className="skill-wrapper section-padding pt-0">
            <div className="container">
                <div
                    className="skill-bg pt-100 pb-100 bg-center bg-cover bg-overlay text-white"
                    style={{
                        backgroundImage: `url(${bgImg})`,
                    }}
                >
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-12 text-center d-none d-xl-block">
                            <img src={leftImg} className="mlm-100" alt="" />
                        </div>
                        <div className="col-xl-6 offset-1 offset-xl-0 col-10 pr-lg-5">
                            <div className="block-contents">
                                <span>Our Expertise</span>
                                <h1>Engineering Excellence Across All Disciplines</h1>
                                <h4>
                                    Our multidisciplinary team combines decades of experience in CAD design, rapid prototyping, and manufacturing optimisation to deliver exceptional results.
                                </h4>
                            </div>
                            {/* PROGRESS BARS */}
                            <SkillBar heading="CAD Design & 3D Scanning" progress="95%" />
                            <SkillBar heading="Rapid Prototyping & Product Development" progress="90%" />
                            <SkillBar heading="Manufacturing Consulting & ISO Conformance" progress="85%" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SkillSet;
